@if (member) {
  {{ [member.firstName, member.infix, member.lastName].join(" ") }}
  @if (isBirthday) {
    🎉
  }
}
@if (!member) {
  ...
}
